export default function (scrollData) {
  const elementHeight = this.offsetHeight

  if (scrollData.currentScroll <= 0) {
    //Element at the absolute top of page
    this.style.marginTop = "0px"
  } else if (scrollData.scrollDiff < 0 && scrollData.footerScrollPosition + scrollData.currentScroll >= -elementHeight) {
      // During downward scroll
      // Closing in on the bottom, reveal the hidden header item
      this.style.marginTop = Math.min(scrollData.currentScroll + scrollData.footerScrollPosition, 0) + "px"
  } else {
    // Downward or upward scroll, using scrollDiff to decide upon visibility
    let currentTopMargin = parseInt(window.getComputedStyle(this).getPropertyValue("margin-top"))
    this.style.marginTop = Math.max(Math.min(currentTopMargin + scrollData.scrollDiff, 0), -elementHeight) + "px"
  }

  if (this.style.marginTop !== '0px') {
    this.classList.add('hiding')
  } else {
    this.classList.remove('hiding')
  }
}
